import baseApi, {transformResponseFromData} from 'store/slices/api/baseApi'

const clientsNotesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getClientNotes: build.query({
            query: (plannerClientKey) => {
                console.log('getClientNotes', {
                    plannerClientKey,
                })
                return {
                    url: `Planner/getClientNotes?plannerClientKey=${plannerClientKey}`,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            providesTags: ['Note'],
        }),
        createClientNote: build.mutation({
            query: (note) => {
                console.log('postClientNotes', {
                    note,
                })
                return {
                    url: 'Planner/postClientNotes',
                    method: 'POST',
                    body: note,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['Note'],
        }),
        saveClientNote: build.mutation({
            query: (note) => {
                console.log('PutClientNotes', {
                    note,
                })
                return {
                    url: 'Planner/putClientNotes',
                    method: 'PUT',
                    body: note,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['Note'],
        }),
        deleteClientNote: build.mutation({
            query: (note) => {
                console.log('postClientNotes', {
                    note: note,
                })
                return {
                    url: 'Planner/deleteClientNotes',
                    method: 'DELETE',
                    body: note,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['Note'],
        }),
    }),
    overrideExisting: false,
})

export default clientsNotesApi

export const {
    useGetClientNotesQuery,
    useCreateClientNoteMutation,
    useDeleteClientNoteMutation,
    useSaveClientNoteMutation,
} = clientsNotesApi
